import { TicketView } from '@trackly/shared';

const buildDefaultTimeTracking = (): TicketView['timeTracking'] => ({
  createdDate: new Date().toISOString(),
  updatedDate: new Date().toISOString(),
  dueDate: undefined,
  resolvedDate: undefined,
  closedDate: undefined,
  age: '0',
  timeToResolution: undefined,
  timeToClosure: undefined,
  timeUntilDue: undefined,
  isOverdue: false,
});

const buildDefaultCommunication = (): TicketView['communication'] => ({
  comments: [],
  resolutionDetails: '',
  hasResolutionDetails: false,
  hasComments: false,
  lastComment: undefined,
  lastActivityDate: undefined,
  totalComments: 0,
});

const buildDefaultCustomerInfo = (): TicketView['customerInfo'] => ({
  customerName: '',
  customerEmail: '',
  customerPhone: '',
  customerDepartment: '',
  customerLocation: '',
  customerRole: '',
  hasContactInfo: false,
  hasCompleteInfo: false,
  displayName: '',
  fullContactInfo: '',
});

export function createDefaultTicket(): TicketView {
  return {
    id: '',
    // No baseline etag yet — this ticket has never been saved (spec 010).
    etag: '',
    identification: {
      title: '',
      description: '',
      category: '',
      tags: [],
    },
    priorityInfo: {
      priority: '',
      urgency: '',
    },
    assignment: {
      assignedTo: '',
      assignedToName: '',
      assignedTeam: '',
      isAssigned: false,
      isUnassigned: true,
      hasIndividualAssignee: false,
      hasTeamAssignment: false,
    },
    workflow: {
      status: 'Draft',
      resolutionStatus: '',
      workflowStage: '',
    },
    timeTracking: buildDefaultTimeTracking(),
    communication: buildDefaultCommunication(),
    customerInfo: buildDefaultCustomerInfo(),

    cpsiAccessRequest: undefined,
    hstAccessRequest: undefined,
    facilityMaintenanceRequest: undefined,
    customApplicationRequest: undefined,
    reportingRequest: undefined,
    
    // Resolution - initialized with empty description
    resolution: {
      description: '',
      category: undefined,
    },
    
    // Convenience properties
    title: '',
    description: '',
    category: '',
    priority: '',
    urgency: '',
    status: 'Draft',
    assignedTo: '',
    assignedToName: '',
    customerName: '',
    createdDate: new Date().toISOString(),
    isResolved: false,
  };
}

